import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ShopByHeaderSection = ({ children, label, labelClassName = '' }) => (
  <div
    className={classNames(
      'flex flex-col mb-4 md:mr-8',
      'last:mr-0',
      'max-[767px]:[&+&]:[border-top:1px_solid_#f1f1f1] max-[767px]:[&+&]:mt-[1.3rem] max-[767px]:[&+&]:pt-[1.3rem]'
    )}
  >
    <h3
      className={`text-xs font-bold text-[#74777a] mb-2 max-[767px]:text-base max-[767px]:font-bold max-[767px]:text-gray ${labelClassName}`}
    >
      {label}
    </h3>
    <div className="items-center flex min-h-[46px]">{children}</div>
  </div>
);

ShopByHeaderSection.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
  labelClassName: PropTypes.string,
};

export default ShopByHeaderSection;
